import { Tooltip } from '@mui/material';
import React, { ReactElement } from 'react';

interface ControlsProps {
  title: string;
  children: ReactElement<any, any>;
}

export const ControlsTooltip: React.FC<ControlsProps> = (props) => {
  return (
    <Tooltip
      title={props.title}
      arrow
      placement='top'
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -5],
              },
            },
          ],
        },
      }}
      componentsProps={{
        tooltip: { sx: { color: '#414141', backgroundColor: '#FFF', boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.14)' } },
        arrow: { sx: { color: '#FFF' } },
      }}
    >
      {props.children}
    </Tooltip>
  );
};
